import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store, AppState, AppFields, take, switchMap } from '../store';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(
    private store: Store<AppState>,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.select(AppFields.App, AppFields.MyTeam).pipe(
      take(1),
      switchMap(team => {
        let newReq: HttpRequest<any> = req.clone();

        if (team && team.teamID) {
          newReq = req.clone({
            headers: req.headers.set('TeamID', team.teamID.toString())
          });
        }

        return next.handle(newReq);
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/interceptor.service.ts